const langList = {
  en: 1,
  es: 2,
  ru: 3,
  uk: 4,
  de: 5,
  fr: 6,
  ar: 7,
}

// if (process.env.REACT_APP_DEBUG)
//   langList.ar = 7

export const LanguageEnum = Object.freeze(langList)

export const LanguageKeysEnum = Object.freeze({
  en: 1,
  es: 2,
  de: 3,
  fr: 4,
  ru: 5,
  uk: 6,
  ar: 7,
})